var map = {
	"./Mr.Yanyk.jpeg": 1885,
	"./backgrounds/main-container.jpg": 9104,
	"./backgrounds/main-theme.png": 3662,
	"./backgrounds/text-section.png": 5942,
	"./contactSection/addressImage.png": 1024,
	"./contactSection/contactEmail.png": 5819,
	"./header/header-background.jpg": 9233,
	"./header/logo-background.png": 1419,
	"./hobbies_page/music.png": 4497,
	"./hobbies_page/reading.png": 2472,
	"./icons/location_icon.svg": 4105,
	"./loader.gif": 7049,
	"./main-photo-home.png": 9195,
	"./skills_section/computer.png": 9889,
	"./skills_section/design.png": 6716,
	"./skills_section/entrepreneaur.png": 9572,
	"./skills_section/innovation.png": 1983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;